import { type } from 'os'
import styled from 'styled-components'

const margin = 'auto 5em'
const colorLine = '#E2E2E2'
const HeaderBackGround = 'white'

type liProps = {
    color:string,
    isSelected:boolean
}

type colorProp = {
    color:string,
    epaycoDelivery?: boolean | null,
}

type searchBarProps = {
    isFoused: boolean;
    color: string;
}

type buttonProps = {
    color: string;
 }

export const Section = styled.section`
    text-align: center;
    margin: ${margin};
    background: #ffffff;
    display:flex;
    justify-content: center;
`
export const Nav = styled.nav`
    font-family: ${props => props.theme.fontFamily};
    font-size: 15px;
    display: flex;
    margin: 1em 2.75em;
    justify-content:  space-evenly;
    align-items: center; 
    // Layout
    flex: 0 1 auto;
    @media (max-width: ${props => props.theme.breakpoints.md}){
        margin: 10px 15px 10px 25px;
        justify-content:  space-evenly;
    } 
    @media (min-width: ${props => props.theme.breakpoints.sm}){
        justify-content: space-around;
    } 
`
export const HeaderImagePrint = styled.div`
    display: none;
    @media print {
        display: block
    }
`

export const HeaderImgContainer = styled.div<any>`
    display: inline-block;
    max-width:200px; 
    max-height:100px;
    margin-right:44px;
    @media (min-width: 992px)
        and (max-width: 1280px){
            margin-right: 10px;
        }
        @media (max-width: ${props => props.theme.breakpoints.md}){
            display: flex;
            justify-content: center;
            max-width:150px; 
            max-height:70px;
            margin-right:0px;
        } 
`

export const HeaderImgMovilContainer = styled.div<any>`
`
export const HeaderImgMovil = styled.img<any>`
    cursor: pointer;
    display:flex;
    justify-content: center;
    margin:auto;
    width: 80px;
    height: 30px;
    object-fit: cover;

    @media (max-width: ${props => props.theme.breakpoints.md}){
        width: 100px;
        height: 40px;
    }
    position: absolute;
    left: 40px;
    top: 7px;

`

export const HeaderImg = styled.img`
    cursor: pointer;
    display:flex;
    justify-content: center;
    margin:auto;
    width: 200px;
    height: 100px;
    object-fit: cover;

    @media (max-width: ${props => props.theme.breakpoints.md}){
        width: 150px;
        height: 70px;
    } 

`

export const Search = styled.form<searchBarProps>`
    box-sizing: border-box;
    display : flex;
    border: 2px solid ${props => props.isFoused ? ` ${props.color}` : 'transparent'};
    border-radius: ${props => props.isFoused ? '8px' : '0'};
    @media (max-width: ${props => props.theme.breakpoints.md}){
        display:none;
    } 

`

export const HeaderContainer = styled.div `
`

export const InputOnly = styled.input`
    padding: 0px;
    margin: 0px;
    display: inline-block;
    min-width: 4em;
    width: 26vw;
    border: 0px;
    /* height:42px; */
    padding-left: 10px;
    color: rgba(173, 173, 173, 1);
    box-sizing: border-box;
    &:focus{
        outline: none !important;
    }
    @media (max-width: 1920px) {
        width: 16vw;
    }

    @media (min-width: 992px)
        and (max-width: 1280px){
            width: 10vw;
        }

    @media (max-width: ${props => props.theme.breakpoints.md}){
        display:none;
    } 
`
export const Select = styled.select `
    display: inline-block;
    outline: none !important;
    min-width: 2em;
    width: 100%;
    border-radius: 0 0 0 0;
    border: 1px solid ${colorLine};
    height:44px;
    font-size:16px;
    text-align-last: center;
    color: #999999;
    &:focus{
        -moz-appearance:none; 
        -webkit-appearance:none;
        appearance:none;
        background: #E2E2E2;
    }

`
export const Button = styled.button`
    cursor: pointer;
    background:${props=>props.color};
    border-radius: 0px 5px 5px 0px;
    min-width: 46px;
    font-size: 18px;
    outline: none; 
     ${props =>  props.name === 'iconSearch' ? 
      `border: 1px solid #E2E2E2;
       border-left: none;` : `border-style: none;`
    }
    padding: 0px;
    margin: 0px;
    @media (max-width: ${props => props.theme.breakpoints.md}){
        display:none;
} 
`

export const InputContainer = styled.div`
    display: flex;
    flex-direction: row;
    padding: 1px;
    border-radius: 6px 0 0 6px;
    border-right: none !important;
    border: 1px solid ${colorLine};
    height: 40px; 
`

export const Li = styled.li<liProps>`
    display: inline-block;
    text-align: center;
    color: #222222;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    margin-left: 20px;
    border-bottom: solid 5px ${HeaderBackGround};
    border-bottom-right-radius: 3px;
    border-bottom-left-radius: 3px;
    cursor:pointer;
    &:hover{
        border-bottom: solid 5px ${props => props.color};
    }

    @media (min-width: 992px)
        and (max-width: 1280px){
            font-size: 14px;
        margin-left: 8px;
        }
    
    @media (max-width: ${props => props.theme.breakpoints.md}){
        display:none;
    }
    ${({ isSelected,color }) => isSelected && `
        border-bottom: solid 5px ${color}
     `}
`


export const Ul = styled.div `
    display: flex;
     @media (max-width: ${props => props.theme.breakpoints.md}){
      display:none;
  } 

`

export const ButtonGeo = styled.button `
    position: relative;
    background: transparent;
    width: auto;
    height: 55px;
    color: #222222;
    font-weight: 700;
    font-size: 16px;
    outline: none;
    cursor: pointer;
    border-style: none;
    display: flex;
    align-items: center;
    & > div {
        display: flex;
    }   
    @media (min-width: 992px)
        and (max-width: 1280px){
            font-size: 14px;

        }
    @media (max-width: ${props => props.theme.breakpoints.md}){
       display:none;
    } 
    @media print {
        display: none;
    }
`
export const MobileLocalization = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
    & > div {
        display: flex;
    }
`
export const ButtonShop = styled.button `
    display: inline-block;
    position: relative; 
    background:${props=>props.color};
    border-radius: 5px 5px 5px 5px;
    width:45px;
    height:44px;
    font-size: 18px;
    outline: none;
    margin-left: 10px;
    cursor: pointer;
    border-style: none;
    @media (max-width: ${props => props.theme.breakpoints.md}){
       display:none;
    } 
    @media print {
        display: none;
    }
`

export const ButtonShopMobile = styled.div`
    display:none;
    @media (max-width: ${props => props.theme.breakpoints.md}){
        display: flex; 
        /* background:#ffffff; */
        width:45px;
        height:30px;
        font-size: 18px;
        cursor: pointer;
        outline: none;
        /* margin-left: 40px; */
        justify-content: flex-end;
        align-items: center;
        position: absolute;
        right: 5%;
    } 
    @media print {
        display: none;
    }
`

export const ButtonLocalizationMobile = styled.div`
    display:none;
    @media (max-width: ${props => props.theme.breakpoints.md}){
        display: flex; 
        /* background:#ffffff; */
        width:45px;
        height:30px;
        font-size: 18px;
        cursor: pointer;
        outline: none;
        /* margin-left: 40px; */
        justify-content: flex-end;
        align-items: center;
        position: absolute;
        right: 15%;
    } 
    @media print {
        display: none;
    }
`

export const NavMobile = styled.div<colorProp>`
    height:54.58px;
    display:grid;
    grid-template-columns: ${props => props.epaycoDelivery ? '15vw 25vw 10vw 15vw 20vw 15vw;' : '1fr 2fr 1fr 1fr 1fr'};
    align-content: center;
    justify-items: center;
    @media print {
        display: flex;
        justify-content: center;
    }
`

export const MobileIconContainer = styled.div`
    display:flex;
    justify-content: space-around;
    align-items: center;
    max-width: 25px;
    max-height: 54.58px;
    height: 100%;

  @media print {
        display: none;
    }
`

export const MobileHeaderTitleContainer = styled.div`
    display:flex;
    align-items: center;
    max-height: 54.58px;
    height: 100%;
    @media print {
        display: none;
    }
`

export const MobileHeaderTitle = styled.label`
    font-weight:600;
    font-size:16px;
    line-height:21.79px;
    @media print {
        display: none;
    }
`

export const CleanSearchImg = styled.div`   
    fill: #999999;
    display:flex;
    justify-content: space-around;
    align-items: center;
    @media print {
        display: none;
    }
    svg {
        width: 30px;
        height: 20px;
    }
`

export const MessageSearch = styled.div`   
    color: red;    
    font-size: 12px;
    margin-left: 0.5rem;
    position: absolute;
`

export const HeaderButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    .header__language-buttons__container {
        span {
            margin-right: 0.15rem;
            margin-left: 0.15rem;
        }
        button {
            font-weight: 400;
            font-size: 0.7rem;
            background-color: #FFFFFF;
            color: #222222;
            border: none;
            padding: 6px;
            border-radius: 5px;
            cursor: pointer;

            @media (min-width: 1280px)
            and (max-width: 1920px) {
                font-size: 1rem;
            }

            @media (min-width: 992px)
            and (max-width: 1280px){
             font-size: 0.8em;
        }
        }

        button:hover {
            background-color: ${props => props.color};
            font-weight: 600;
            color: #FFF;
            transition: 0.2s ease-in-out;
         }

        button.active-language {
            background-color: ${props => props.color};
            color: #FFF;
            font-weight: 600;
            color: #FFF;
        }

    }
`